import React, { useState, useEffect } from "react";
import { Button, FormFieldSet, Modal, showToast } from "../../../../components";
import common from "../../../../utils/common";
import { option } from "framer-motion/client";
import { handleVerifyGmail } from "../../../../utils/benchsales/GmailAuth";
import { getGmailAccountsBs } from "../../../../redux/slices/ats/benchSales/benchSalesApi";
import { handleVerifyOutlook } from "../../../../utils/benchsales/OutlookAuth";

const { decryptAll, encryptAll } = common;

// const INTEGRATION_CONFIGS = {
//   3: {
//     // Job Board
//     1: {
//       // Monster
//       name: "Monster",
//       fields: [
//         // { name: "username", label: "Username", type: "text", required: true },
//         { name: "name", label: "Display Name", type: "text", required: true },
//         { name: "clientId", label: "Client ID", type: "text", required: true },
//         {
//           name: "clientSecret",
//           label: "Client Secret",
//           type: "text",
//           required: true,
//         },
//         { name: "cat", label: "CAT", type: "text", required: true },
//         { name: "activeDate", label: "Active Date", type: "datepicker" },
//         { name: "expireDate", label: "Expire Date", type: "datepicker" },
//         { name: "purchased", label: "Purchased Credits", type: "text" },
//       ],
//       hasCheckbox: true,
//       checkboxLabel:
//         "Create candidate/pipeline directly (if applied through Monster)",
//       hasSettings: true,
//     },
//     2: {
//       // Shine
//       name: "Career Builder",
//       fields: [
//         { name: "name", label: "Display Name", type: "text", required: true },
//         { name: "email", label: "Email", type: "text", required: true },
//         { name: "password", label: "Password", type: "text", required: true },
//         {
//           name: "custAccCode",
//           label: "Customer Access Code",
//           type: "text",
//           required: true,
//         },
//       ],
//       hasCheckbox: false,
//       hasSettings: true,
//     },
//     3: {
//       // Naukri
//       name: "Naukri",
//       fields: [
//         {
//           name: "accountId",
//           label: "Account ID",
//           type: "text",
//           required: true,
//         },
//         {
//           name: "displayName",
//           label: "Display Name",
//           type: "text",
//           required: true,
//         },
//         {
//           name: "apiSecret",
//           label: "API Secret",
//           type: "text",
//           required: true,
//         },
//         {
//           name: "companyId",
//           label: "Company ID",
//           type: "text",
//           required: true,
//         },
//       ],
//       hasCheckbox: false,
//       hasSettings: false,
//     },
//     4: {
//       // LinkedIn
//       name: "LinkedIn",
//       fields: [
//         {
//           name: "companyPage",
//           label: "Company Page",
//           type: "text",
//           required: true,
//         },
//         {
//           name: "displayName",
//           label: "Display Name",
//           type: "text",
//           required: true,
//         },
//         {
//           name: "accessToken",
//           label: "Access Token",
//           type: "text",
//           required: true,
//         },
//         {
//           name: "organizationId",
//           label: "Organization ID",
//           type: "text",
//           required: true,
//         },
//       ],
//       hasCheckbox: true,
//       checkboxLabel: "Auto-sync job postings to LinkedIn",
//       hasSettings: true,
//     },
//     5: {
//       // ZipRecruiter
//       name: "ZipRecruiter",
//       fields: [
//         {
//           name: "apiKey",
//           label: "API Key",
//           type: "text",
//           required: true,
//         },
//         {
//           name: "displayName",
//           label: "Display Name",
//           type: "text",
//           required: true,
//         },
//         {
//           name: "accountEmail",
//           label: "Account Email",
//           type: "email",
//           required: true,
//         },
//       ],
//       hasCheckbox: false,
//       hasSettings: false,
//     },
//     6: {
//       // Jora
//       name: "Jora",
//       fields: [
//         { name: "username", label: "Username", type: "text", required: true },
//         {
//           name: "displayName",
//           label: "Display Name",
//           type: "text",
//           required: true,
//         },
//         {
//           name: "apiToken",
//           label: "API Token",
//           type: "text",
//           required: true,
//         },
//       ],
//       hasCheckbox: false,
//       hasSettings: false,
//     },
//   },
//   6: {
//     1: {
//       name: "Open AI",
//       fields: [
//         { name: "name", label: "Display Name", type: "text", required: true, isEncrypted: false },
//         { name: "key", label: "API Key", type: "text", required: true, isEncrypted: true, },
//         { name: "model", label: "Model", type: "text", required: true, isEncrypted: true, },
//         { name: "serviceType", label: "Service Type", type: "select", required: true, isEncrypted: false,
//           options: [{label: "Parse Resume", value: 1}, {label: "Optimize Resume", value: 2}] }
//       ],
//     },
//     2: {
//       name: "Kult AI Call",
//       fields: [
//         { name: "name", label: "Display Name", type: "text", required: true },
//         { name: "apiKey", label: "API Key", type: "text", required: true, },
//         { name: "assistantId", label: "Assistant Id", type: "text", required: true, },
//         { name: "phoneId", label: "Phone Id", type: "text", required: true}
//       ],
//     },
//   },
//   11: {
//     // Bulk Email
//     1: {
//       // G-suite
//       name: "G-suite",
//       fields: [
//         {
//           name: "name",
//           label: "Display Name",
//           type: "text",
//           required: true,
//           isEncrypted: false
//         },
//         {
//           name: "access_type",
//           label: "Type",
//           type: "text",
//           required: true,
//           isEncrypted: true
//         },
//         {
//           name: "project_id",
//           label: "Project ID",
//           type: "text",
//           required: true,
//           isEncrypted: true
//         },
//         {
//           name: "private_key_id",
//           label: "Private Key ID",
//           type: "text",
//           required: true,
//           isEncrypted: true
//         },
//         {
//           name: "private_key",
//           label: "Private Key",
//           type: "text",
//           required: true,
//           isEncrypted: true
//         },
//         {
//           name: "client_email",
//           label: "Client Email Address",
//           type: "text",
//           required: true,
//           isEncrypted: true
//         },
//         {
//           name: "client_id",
//           label: "Client ID",
//           type: "text",
//           required: true,
//           isEncrypted: true
//         },
//         // {
//         //   name: "clientSecret",
//         //   label: "Client Secret",
//         //   type: "password",
//         //   required: true,
//         // },
//         {
//           name: "auth_uri",
//           label: "Auth URL",
//           type: "text",
//           required: true,
//           isEncrypted: true
//         },
//         {
//           name: "token_uri",
//           label: "Token URL",
//           type: "text",
//           required: true,
//           isEncrypted: true
//         },
//         {
//           name: "auth_provider_x509_cert_url",
//           label: "Auth Provider URL",
//           type: "text",
//           required: true,
//           isEncrypted: true
//         },
//         {
//           name: "client_x509_cert_url",
//           label: "Client Certificate URL",
//           type: "text",
//           required: true,
//           isEncrypted: true
//         },
//         {
//           name: "universe_domain",
//           label: "Domain",
//           type: "text",
//           required: true,
//           isEncrypted: true
//         },
//         {
//           name: "delayBetweenEmailsMin",
//           label: "Minimum Delay Between Mails",
//           type: "text",
//           isEncrypted: true
//         },
//         {
//           name: "delayBetweenEmailsMax",
//           label: "Maximum Delay Between Mails",
//           type: "text",
//           isEncrypted: true
//         },
//         {
//           name: "delayBetweenBatchesMin",
//           label: "Minimum Delay Between Batches",
//           type: "text",
//           isEncrypted: true
//         },
//         {
//           name: "delayBetweenBatchesMax",
//           label: "Maximum Delay Between Batches",
//           type: "text",
//           isEncrypted: true
//         },
//         {
//           name: "totalLimit",
//           label: "Daily Total Limit",
//           type: "text",
//           isEncrypted: true
//         },
//       ],
//       hasCheckbox: false,
//       hasSettings: true,
//     },
//     2: {
//       // Outlook
//       name: "Outlook",
//       fields: [
//         // {
//         //   name: "email",
//         //   label: "Email Address",
//         //   type: "email",
//         //   required: true,
//         // },
//         {
//           name: "name",
//           label: "Display Name",
//           type: "text",
//           required: true,
//           isEncrypted: false
//         },
//         {
//           name: "tenantId",
//           label: "Tenant ID",
//           type: "text",
//           required: true,
//           isEncrypted: true
//         },
//         {
//           name: "clientId",
//           label: "Client ID",
//           type: "text",
//           required: true,
//           isEncrypted: true
//         },
//         {
//           name: "clientSecret",
//           label: "Client Secret",
//           type: "text",
//           required: true,
//           isEncrypted: true
//         },
//         {
//           name: "delayBetweenEmailsMin",
//           label: "Minimum Delay Between Mails",
//           type: "text",
//           isEncrypted: true
//         },
//         {
//           name: "delayBetweenEmailsMax",
//           label: "Maximum Delay Between Mails",
//           type: "text",
//           isEncrypted: true
//         },
//         {
//           name: "delayBetweenBatchesMin",
//           label: "Minimum Delay Between Batches",
//           type: "text",
//           isEncrypted: true
//         },
//         {
//           name: "delayBetweenBatchesMax",
//           label: "Maximum Delay Between Batches",
//           type: "text",
//           isEncrypted: true
//         },
//         {
//           name: "totalLimit",
//           label: "Daily Total Limit",
//           type: "text",
//           isEncrypted: true
//         },
//       ],
//       hasCheckbox: false,
//       hasSettings: true,
//     },
//     3: {
//       // Mailgun
//       name: "Mailgun",
//       fields: [
//         {
//           name: "apiKey",
//           label: "API Key",
//           type: "text",
//           required: true,
//         },
//         {
//           name: "name",
//           label: "Display Name",
//           type: "text",
//           required: true,
//         },
//         { name: "domain", label: "Domain", type: "text", required: true },
//         // { name: "region", label: "Region", type: "text", required: true },
//         {
//           name: "delayBetweenEmailsMin",
//           label: "Minimum Delay Between Mails",
//           type: "text",
//         },
//         {
//           name: "delayBetweenEmailsMax",
//           label: "Maximum Delay Between Mails",
//           type: "text",
//         },
//         {
//           name: "delayBetweenBatchesMin",
//           label: "Minimum Delay Between Batches",
//           type: "text",
//         },
//         {
//           name: "delayBetweenBatchesMax",
//           label: "Maximum Delay Between Batches",
//           type: "text",
//         },
//         {
//           name: "totalLimit",
//           label: "Daily Total Limit",
//           type: "text",
//         },
//       ],
//       hasCheckbox: false,
//       hasSettings: false,
//     },
//     4: {
//       // AWS SES
//       name: "AWS SES",
//       fields: [
//         // {
//         //   name: "accessKeyId",
//         //   label: "Access Key ID",
//         //   type: "text",
//         //   required: true,
//         // },
//         {
//           name: "name",
//           label: "Display Name",
//           type: "text",
//           required: true,
//         },
//         // {
//         //   name: "secretAccessKey",
//         //   label: "Secret Access Key",
//         //   type: "password",
//         //   required: true,
//         // },
//         { name: "region", label: "AWS Region", type: "text", required: true },
//         {
//           name: "delayBetweenEmailsMin",
//           label: "Minimum Delay Between Mails",
//           type: "text",
//         },
//         {
//           name: "delayBetweenEmailsMax",
//           label: "Maximum Delay Between Mails",
//           type: "text",
//         },
//         {
//           name: "delayBetweenBatchesMin",
//           label: "Minimum Delay Between Batches",
//           type: "text",
//         },
//         {
//           name: "delayBetweenBatchesMax",
//           label: "Maximum Delay Between Batches",
//           type: "text",
//         },
//         {
//           name: "totalLimit",
//           label: "Daily Total Limit",
//           type: "text",
//         },
//       ],
//       hasCheckbox: false,
//       hasSettings: false,
//     },
//     5: {
//       // Instantly
//       name: "Instantly",
//       fields: [
//         {
//           name: "name",
//           label: "Display Name",
//           type: "text",
//           required: true,
//         },
//         {
//           name: "apiKey",
//           label: "API Key",
//           type: "text",
//           required: true,
//         },
//         {
//           name: "delayBetweenEmailsMin",
//           label: "Minimum Delay Between Mails",
//           type: "text",
//         },
//         {
//           name: "delayBetweenEmailsMax",
//           label: "Maximum Delay Between Mails",
//           type: "text",
//         },
//         {
//           name: "delayBetweenBatchesMin",
//           label: "Minimum Delay Between Batches",
//           type: "text",
//         },
//         {
//           name: "delayBetweenBatchesMax",
//           label: "Maximum Delay Between Batches",
//           type: "text",
//         },
//         {
//           name: "totalLimit",
//           label: "Daily Total Limit",
//           type: "text",
//         },
//         // {
//         //   name: "workspaceId",
//         //   label: "Workspace ID",
//         //   type: "text",
//         //   required: true,
//         // },
//       ],
//       hasCheckbox: false,
//       hasSettings: false,
//     },
//   },
//   1: {
//     1: {
//       name: "VOIP Office CRM",
//       fields: [
//         {
//           name: "apiEndpoint",
//           label: "API Endpoint",
//           type: "text",
//           required: true,
//         },
//         {
//           name: "apiKey",
//           label: "API Key",
//           type: "text",
//           required: true,
//         },
//         {
//           name: "displayName",
//           label: "Display Name",
//           type: "text",
//           required: true,
//         },
//         {
//           name: "extensionNumber",
//           label: "Extension Number",
//           type: "text",
//           required: false,
//         },
//       ],
//       hasCheckbox: false,
//       hasSettings: true,
//     },
//     2: {
//       name: "ZOOM",
//       fields: [
//         {
//           name: "accountId",
//           label: "Account ID",
//           type: "text",
//           required: true,
//         },
//         {
//           name: "name",
//           label: "Display Name",
//           type: "text",
//           required: true,
//         },
//         {
//           name: "clientId",
//           label: "Client ID",
//           type: "text",
//           required: true,
//         },
//         {
//           name: "clientSecret",
//           label: "Client Secret",
//           type: "text",
//           required: true,
//         },
//       ],
//       hasCheckbox: false,
//       hasSettings: false,
//     },
//   },
//   2: {
//     // VMS
//     1: {
//       // VOIP Office CRM
//       name: "VOIP Office CRM",
//       fields: [
//         {
//           name: "apiEndpoint",
//           label: "API Endpoint",
//           type: "text",
//           required: true,
//         },
//         {
//           name: "apiKey",
//           label: "API Key",
//           type: "text",
//           required: true,
//         },
//         {
//           name: "displayName",
//           label: "Display Name",
//           type: "text",
//           required: true,
//         },
//       ],
//       hasCheckbox: false,
//       hasSettings: false,
//     },
//   },
//   7: {
//     // Productivity
//     1: {
//       // Google Search API
//       name: "Google Search API",
//       fields: [
//         {
//           name: "clientID",
//           label: "Client ID",
//           type: "text",
//           required: true,
//         },
//         {
//           name: "name",
//           label: "Display Name",
//           type: "text",
//           required: true,
//         },
//         {
//           name: "clientSecret",
//           label: "Client Secret",
//           type: "text",
//           required: true,
//         },
//       ],
//       hasCheckbox: false,
//       hasSettings: false,
//     },
//     2: {
//       // Apollo API
//       name: "Apollo API",
//       fields: [
//         {
//           name: "name",
//           label: "Display Name",
//           type: "text",
//           required: true,
//           isEncrypted: false,
//         },
//         {
//           name: "clientID",
//           label: "Client ID",
//           type: "text",
//           required: true,
//           isEncrypted: true,
//         },
//         {
//           name: "clientSecret",
//           label: "Client Secret",
//           type: "text",
//           required: true,
//           isEncrypted: true,
//         },
//         {
//           name: "redirectUri",
//           label: "Redirect Uri",
//           type: "text",
//           required: true,
//           isEncrypted: true,
//         },
//         {
//           name: "callbackRedirect",
//           label: "Callback Redirect",
//           type: "text",
//           required: true,
//           isEncrypted: true,
//         },
//         {
//           name: "endpoint",
//           label: "Endpoint",
//           type: "text",
//           required: true,
//           isEncrypted: true,
//         },
//         {
//           name: "webhookUrl",
//           label: "Webhook Url",
//           type: "text",
//           required: true,
//           isEncrypted: true,
//         },
//       ],
//       hasCheckbox: false,
//       hasSettings: false,
//     },
//   },
//   9: {
//     // Video Interview
//     1: {
//       name: "Zoom",
//       hasCheckbox: true,
//       checkboxLabel:
//         "Create candidate/pipeline directly (if applied through Monster)",
//       hasSettings: true,
//     },
//   },
// };

const INTEGRATION_CONFIGS = {
  3: {
    // Job Board
    1: {
      // Monster
      name: "Monster",
      fields: [
        {
          name: "name",
          label: "Display Name",
          type: "text",
          required: true,
          isEncrypted: false,
        },
        {
          name: "clientId",
          label: "Client ID",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "clientSecret",
          label: "Client Secret",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "cat",
          label: "CAT",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "activeDate",
          label: "Active Date",
          type: "datepicker",
          isEncrypted: true,
        },
        {
          name: "expireDate",
          label: "Expire Date",
          type: "datepicker",
          isEncrypted: true,
        },
        {
          name: "purchased",
          label: "Purchased Credits",
          type: "text",
          isEncrypted: true,
        },
      ],
      hasCheckbox: true,
      checkboxLabel:
        "Create candidate/pipeline directly (if applied through Monster)",
      hasSettings: true,
    },
    2: {
      // Career Builder
      name: "Career Builder",
      fields: [
        {
          name: "name",
          label: "Display Name",
          type: "text",
          required: true,
          isEncrypted: false,
        },
        {
          name: "email",
          label: "Email",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "password",
          label: "Password",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "custAccCode",
          label: "Customer Access Code",
          type: "text",
          required: true,
          isEncrypted: true,
        },
      ],
      hasCheckbox: false,
      hasSettings: true,
    },
    3: {
      // Naukri
      name: "Naukri",
      fields: [
        {
          name: "accountId",
          label: "Account ID",
          type: "text",
          required: true,
        },
        {
          name: "displayName",
          label: "Display Name",
          type: "text",
          required: true,
        },
        {
          name: "apiSecret",
          label: "API Secret",
          type: "text",
          required: true,
        },
        {
          name: "companyId",
          label: "Company ID",
          type: "text",
          required: true,
        },
      ],
      hasCheckbox: false,
      hasSettings: false,
    },
    4: {
      // LinkedIn
      name: "LinkedIn",
      fields: [
        {
          name: "companyPage",
          label: "Company Page",
          type: "text",
          required: true,
        },
        {
          name: "displayName",
          label: "Display Name",
          type: "text",
          required: true,
        },
        {
          name: "accessToken",
          label: "Access Token",
          type: "text",
          required: true,
        },
        {
          name: "organizationId",
          label: "Organization ID",
          type: "text",
          required: true,
        },
      ],
      hasCheckbox: true,
      checkboxLabel: "Auto-sync job postings to LinkedIn",
      hasSettings: true,
    },
    5: {
      // ZipRecruiter
      name: "ZipRecruiter",
      fields: [
        {
          name: "apiKey",
          label: "API Key",
          type: "text",
          required: true,
        },
        {
          name: "displayName",
          label: "Display Name",
          type: "text",
          required: true,
        },
        {
          name: "accountEmail",
          label: "Account Email",
          type: "email",
          required: true,
        },
      ],
      hasCheckbox: false,
      hasSettings: false,
    },
    6: {
      // Jora
      name: "Jora",
      fields: [
        { name: "username", label: "Username", type: "text", required: true },
        {
          name: "displayName",
          label: "Display Name",
          type: "text",
          required: true,
        },
        {
          name: "apiToken",
          label: "API Token",
          type: "text",
          required: true,
        },
      ],
      hasCheckbox: false,
      hasSettings: false,
    },
  },
  6: {
    1: {
      name: "Kult AI",
      fields: [
        {
          name: "name",
          label: "Display Name",
          type: "text",
          required: true,
          isEncrypted: false,
        },
        {
          name: "key",
          label: "API Key",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "model",
          label: "Model",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "serviceType",
          label: "Service Type",
          type: "select",
          required: true,
          isEncrypted: false,
          options: [
            { label: "Parse Resume", value: 1 },
            { label: "Optimize Resume", value: 2 },
            { label: "AI Draft", value: 3 },
          ],
        },
      ],
    },
    2: {
      name: "Kult AI Call",
      fields: [
        {
          name: "name",
          label: "Display Name",
          type: "text",
          required: true,
          isEncrypted: false,
        },
        {
          name: "apiKey",
          label: "API Key",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "assistantId",
          label: "Assistant Id",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "phoneId",
          label: "Phone Id",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "callType",
          label: "Call Type",
          type: "select",
          required: true,
          isEncrypted: false,
          options: [
            { label: "Outbound Call", value: 1 },
            { label: "Inbound Call", value: 2 },
          ],
        },
      ],
    },
  },
  11: {
    // Bulk Email
    1: {
      // G-suite
      name: "G-suite",
      fields: [
        {
          name: "name",
          label: "Display Name",
          type: "text",
          required: true,
          isEncrypted: false,
        },
        {
          name: "access_type",
          label: "Type",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "project_id",
          label: "Project ID",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "private_key_id",
          label: "Private Key ID",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "private_key",
          label: "Private Key",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "client_email",
          label: "Client Email Address",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "client_id",
          label: "Client ID",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        // {
        //   name: "clientSecret",
        //   label: "Client Secret",
        //   type: "password",
        //   required: true,
        // },
        {
          name: "auth_uri",
          label: "Auth URL",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "token_uri",
          label: "Token URL",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "auth_provider_x509_cert_url",
          label: "Auth Provider URL",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "client_x509_cert_url",
          label: "Client Certificate URL",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "universe_domain",
          label: "Domain",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "delayBetweenEmailsMin",
          label: "Minimum Delay Between Mails",
          type: "text",
          isEncrypted: true,
        },
        {
          name: "delayBetweenEmailsMax",
          label: "Maximum Delay Between Mails",
          type: "text",
          isEncrypted: true,
        },
        {
          name: "delayBetweenBatchesMin",
          label: "Minimum Delay Between Batches",
          type: "text",
          isEncrypted: true,
        },
        {
          name: "delayBetweenBatchesMax",
          label: "Maximum Delay Between Batches",
          type: "text",
          isEncrypted: true,
        },
        {
          name: "totalLimit",
          label: "Daily Total Limit",
          type: "text",
          isEncrypted: true,
        },
      ],
      hasCheckbox: false,
      hasSettings: true,
    },
    2: {
      // Outlook
      name: "Outlook",
      fields: [
        // {
        //   name: "email",
        //   label: "Email Address",
        //   type: "email",
        //   required: true,
        // },
        {
          name: "name",
          label: "Display Name",
          type: "text",
          required: true,
          isEncrypted: false,
        },
        {
          name: "tenantId",
          label: "Tenant ID",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "clientId",
          label: "Client ID",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "clientSecret",
          label: "Client Secret",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "delayBetweenEmailsMin",
          label: "Minimum Delay Between Mails",
          type: "text",
          isEncrypted: true,
        },
        {
          name: "delayBetweenEmailsMax",
          label: "Maximum Delay Between Mails",
          type: "text",
          isEncrypted: true,
        },
        {
          name: "delayBetweenBatchesMin",
          label: "Minimum Delay Between Batches",
          type: "text",
          isEncrypted: true,
        },
        {
          name: "delayBetweenBatchesMax",
          label: "Maximum Delay Between Batches",
          type: "text",
          isEncrypted: true,
        },
        {
          name: "totalLimit",
          label: "Daily Total Limit",
          type: "text",
          isEncrypted: true,
        },
      ],
      hasCheckbox: false,
      hasSettings: true,
    },
    3: {
      // Mailgun
      name: "Mailgun",
      fields: [
        {
          name: "apiKey",
          label: "API Key",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "name",
          label: "Display Name",
          type: "text",
          required: true,
          isEncrypted: false,
        },
        {
          name: "domain",
          label: "Domain",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        // { name: "region", label: "Region", type: "text", required: true },
        {
          name: "delayBetweenEmailsMin",
          label: "Minimum Delay Between Mails",
          type: "text",
          isEncrypted: true,
        },
        {
          name: "delayBetweenEmailsMax",
          label: "Maximum Delay Between Mails",
          type: "text",
          isEncrypted: true,
        },
        {
          name: "delayBetweenBatchesMin",
          label: "Minimum Delay Between Batches",
          type: "text",
          isEncrypted: true,
        },
        {
          name: "delayBetweenBatchesMax",
          label: "Maximum Delay Between Batches",
          type: "text",
          isEncrypted: true,
        },
        {
          name: "totalLimit",
          label: "Daily Total Limit",
          type: "text",
          isEncrypted: true,
        },
      ],
      hasCheckbox: false,
      hasSettings: false,
    },
    4: {
      // AWS SES
      name: "AWS SES",
      fields: [
        // {
        //   name: "accessKeyId",
        //   label: "Access Key ID",
        //   type: "text",
        //   required: true,
        // },
        {
          name: "name",
          label: "Display Name",
          type: "text",
          required: true,
          isEncrypted: false,
        },
        // {
        //   name: "secretAccessKey",
        //   label: "Secret Access Key",
        //   type: "password",
        //   required: true,
        // },
        {
          name: "region",
          label: "AWS Region",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "delayBetweenEmailsMin",
          label: "Minimum Delay Between Mails",
          type: "text",
          isEncrypted: true,
        },
        {
          name: "delayBetweenEmailsMax",
          label: "Maximum Delay Between Mails",
          type: "text",
          isEncrypted: true,
        },
        {
          name: "delayBetweenBatchesMin",
          label: "Minimum Delay Between Batches",
          type: "text",
          isEncrypted: true,
        },
        {
          name: "delayBetweenBatchesMax",
          label: "Maximum Delay Between Batches",
          type: "text",
          isEncrypted: true,
        },
        {
          name: "totalLimit",
          label: "Daily Total Limit",
          type: "text",
          isEncrypted: true,
        },
      ],
      hasCheckbox: false,
      hasSettings: false,
    },
    5: {
      // Instantly
      name: "Instantly",
      fields: [
        {
          name: "name",
          label: "Display Name",
          type: "text",
          required: true,
          isEncrypted: false,
        },
        {
          name: "apiKey",
          label: "API Key",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "delayBetweenEmailsMin",
          label: "Minimum Delay Between Mails",
          type: "text",
          isEncrypted: true,
        },
        {
          name: "delayBetweenEmailsMax",
          label: "Maximum Delay Between Mails",
          type: "text",
          isEncrypted: true,
        },
        {
          name: "delayBetweenBatchesMin",
          label: "Minimum Delay Between Batches",
          type: "text",
          isEncrypted: true,
        },
        {
          name: "delayBetweenBatchesMax",
          label: "Maximum Delay Between Batches",
          type: "text",
          isEncrypted: true,
        },
        {
          name: "totalLimit",
          label: "Daily Total Limit",
          type: "text",
          isEncrypted: true,
        },
        // {
        //   name: "workspaceId",
        //   label: "Workspace ID",
        //   type: "text",
        //   required: true,
        // },
      ],
      hasCheckbox: false,
      hasSettings: false,
    },
    6: {
      // Send Grid
      name: "Send Grid",
      fields: [
        {
          name: "name",
          label: "Display Name",
          type: "text",
          required: true,
          isEncrypted: false,
        },
        {
          name: "apiKey",
          label: "API Key",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "delayBetweenEmailsMin",
          label: "Minimum Delay Between Mails",
          type: "text",
          isEncrypted: true,
        },
        {
          name: "delayBetweenEmailsMax",
          label: "Maximum Delay Between Mails",
          type: "text",
          isEncrypted: true,
        },
        {
          name: "delayBetweenBatchesMin",
          label: "Minimum Delay Between Batches",
          type: "text",
          isEncrypted: true,
        },
        {
          name: "delayBetweenBatchesMax",
          label: "Maximum Delay Between Batches",
          type: "text",
          isEncrypted: true,
        },
        {
          name: "totalLimit",
          label: "Daily Total Limit",
          type: "text",
          isEncrypted: true,
        },
      ],
      hasCheckbox: false,
      hasSettings: false,
    },
    7: {
      name: "Gmail",
      fields: [
        {
          name: "name",
          label: "Display Name",
          type: "text",
          required: true,
          isEncrypted: false,
        },
        // {
        //   name: "source",
        //   label: "source",
        //   type: "select",
        //   required: true,
        //   isEncrypted: true,
        //   options: [
        //     { label: "Outlook", value: 1 },
        //     // { label: "OAuth2", value: "oauth2" },
        //   ],
        // },
      ],
      hasCheckbox: false,
      hasSettings: false,
    },
    8: {
      name: "Outlook",
      fields: [
        {
          name: "name",
          label: "Display Name",
          type: "text",
          required: true,
          isEncrypted: false,
        },
        // {
        //   name: "source",
        //   label: "source",
        //   type: "select",
        //   required: true,
        //   isEncrypted: true,
        //   options: [
        //     { label: "Outlook", value: 1 },
        //     // { label: "OAuth2", value: "oauth2" },
        //   ],
        // },
      ],
      hasCheckbox: false,
      hasSettings: false,
    },
  },

  1: {
    1: {
      name: "VOIP Office CRM",
      fields: [
        {
          name: "apiEndpoint",
          label: "API Endpoint",
          type: "text",
          required: true,
        },
        {
          name: "apiKey",
          label: "API Key",
          type: "text",
          required: true,
        },
        {
          name: "displayName",
          label: "Display Name",
          type: "text",
          required: true,
        },
        {
          name: "extensionNumber",
          label: "Extension Number",
          type: "text",
          required: false,
        },
      ],
      hasCheckbox: false,
      hasSettings: true,
    },
    2: {
      name: "ZOOM",
      fields: [
        {
          name: "accountId",
          label: "Account ID",
          type: "text",
          required: true,
        },
        {
          name: "name",
          label: "Display Name",
          type: "text",
          required: true,
        },
        {
          name: "clientId",
          label: "Client ID",
          type: "text",
          required: true,
        },
        {
          name: "clientSecret",
          label: "Client Secret",
          type: "text",
          required: true,
        },
      ],
      hasCheckbox: false,
      hasSettings: false,
    },
  },
  2: {
    // VMS
    1: {
      // VOIP Office CRM
      name: "VOIP Office CRM",
      fields: [
        {
          name: "apiEndpoint",
          label: "API Endpoint",
          type: "text",
          required: true,
        },
        {
          name: "apiKey",
          label: "API Key",
          type: "text",
          required: true,
        },
        {
          name: "displayName",
          label: "Display Name",
          type: "text",
          required: true,
        },
      ],
      hasCheckbox: false,
      hasSettings: false,
    },
  },
  7: {
    // Productivity
    1: {
      // Google Search API
      name: "Google Search API",
      fields: [
        {
          name: "clientID",
          label: "Client ID",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "name",
          label: "Display Name",
          type: "text",
          required: true,
          isEncrypted: false,
        },
        {
          name: "clientSecret",
          label: "Client Secret",
          type: "text",
          required: true,
          isEncrypted: true,
        },
      ],
      hasCheckbox: false,
      hasSettings: false,
    },
    2: {
      // Apollo API
      name: "Apollo API",
      fields: [
        {
          name: "name",
          label: "Display Name",
          type: "text",
          required: true,
          isEncrypted: false,
        },
        {
          name: "apiKey",
          label: "Api Key",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "endpoint",
          label: "Endpoint",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "clientID",
          label: "Client ID",
          type: "text",
          //required: true,
          isEncrypted: true,
        },
        {
          name: "clientSecret",
          label: "Client Secret",
          type: "text",
          //required: true,
          isEncrypted: true,
        },
        {
          name: "redirectUri",
          label: "Redirect Uri",
          type: "text",
          //required: true,
          isEncrypted: true,
        },
        {
          name: "callbackRedirect",
          label: "Callback Redirect",
          type: "text",
          // required: true,
          isEncrypted: true,
        },
        {
          name: "webhookUrl",
          label: "Webhook Url",
          type: "text",
          //required: true,
          isEncrypted: true,
        },
      ],
      hasCheckbox: false,
      hasSettings: false,
    },
  },
  9: {
    // Video Interview
    1: {
      name: "Zoom",
      hasCheckbox: true,
      checkboxLabel:
        "Create candidate/pipeline directly (if applied through Monster)",
      hasSettings: true,
    },
  },
  12: {
    1: {
      name: "Valid Emails",
      fields: [
        {
          name: "name",
          label: "Display Name",
          type: "text",
          required: true,
          isEncrypted: false,
        },
        {
          name: "apikey",
          label: "API Key",
          type: "text",
          required: true,
          isEncrypted: true,
        },
      ],
    },
    2: {
      name: "Mailgun",
      fields: [
        {
          name: "name",
          label: "Display Name",
          type: "text",
          required: true,
          isEncrypted: false,
        },
        {
          name: "apikey",
          label: "API Key",
          type: "text",
          required: true,
          isEncrypted: true,
        },
        {
          name: "domain",
          label: "Domain",
          type: "text",
          required: true,
          isEncrypted: true,
        },
      ],
    },
  },
};

const AddAccountModel = ({
  isOpen,
  onClose,
  category,
  type,
  existingData,
  onSave,
  isEditMode = false,
  selectedModule,
}) => {
  const [formData, setFormData] = useState({});
  const config = INTEGRATION_CONFIGS[category]?.[type];
  const [errors, setErrors] = useState({});

  if (!config) return null;

  const validateForm = () => {
    const newErrors = {};

    config?.fields.forEach((field) => {
      const value = formData[field.name];

      if (field.required) {
        const isEmpty =
          value === undefined ||
          value === null ||
          (typeof value === "string" && value.trim() === "") ||
          (typeof value === "number" && isNaN(value));

        if (isEmpty) {
          newErrors[field.name] = `${field.label} is required`;
          return;
        }
      }

      if ((field.type === "email" || field.name === "client_email") && value) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
          newErrors[field.name] = "Please enter a valid email address";
        }
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    if (!validateForm()) return;

    if (category === 3 && type === 1) {
      const purchasedValue = formData?.purchased;

      if (purchasedValue !== "") {
        if (isNaN(Number(purchasedValue))) {
          showToast("Purchased Creits must be a valid number", "error");
          return;
        }
      }
    }

    if (isEditMode) {
      let updateValue = {};

      if (selectedModule === "bs") {
        config?.fields?.forEach((item) => {
          if (item.name !== "name") {
            updateValue[item.name] = item?.isEncrypted
              ? encryptAll(formData[item.name])
              : formData[item.name];
          }
        });

        if (category === 3 && type === 1) {
          const { purchased, ...rest } = updateValue;
          updateValue = { ...rest, credits: { purchased } };
        } else if (category === 3 && type === 2) {
          const { email, password, custAccCode } = updateValue;
          updateValue = {
            credentials: { email, password },
            custAccCode,
          };
        }

        updateValue.name = formData.name;
      } else {
        let configData = {};
        config?.fields?.forEach((item) => {
          if (item.name !== "name") {
            configData[item.name] = item?.isEncrypted
              ? encryptAll(formData[item.name])
              : formData[item.name];
          }
        });

        if (category === 3 && type === 1) {
          const { purchased, ...rest } = configData;
          configData = { ...rest, credits: { purchased } };
        } else if (category === 3 && type === 2) {
          const { email, password, custAccCode } = configData;
          configData = {
            credentials: { email, password },
            custAccCode,
          };
        }
        ((updateValue.name = formData.name), (updateValue.config = configData));
      }

      onSave({
        payload: [
          {
            type: "SET",
            value: updateValue,
          },
        ],
        uiid: existingData?.uiid,
        isEditMode,
        category,
        type,
        name: formData.name,
        selectedModule,
      });
      onClose();
      setInitialFormData();
    } else {
      let { name, ...rest } = formData;

      let updatedConfig = {};

      config?.fields?.forEach((item) => {
        if (item.name !== "name") {
          updatedConfig[item.name] = item?.isEncrypted
            ? encryptAll(formData[item.name])
            : formData[item.name];
        }
      });

      if (category === 3 && type === 1) {
        const { purchased, ...rest } = updatedConfig;
        updatedConfig = { ...rest, credits: { purchased } };
      } else if (category === 3 && type === 2) {
        const { email, password, custAccCode } = updatedConfig;
        updatedConfig = {
          credentials: { email, password },
          custAccCode,
        };
      }

      onSave({
        updatedConfig,
        category,
        type,
        name: formData.name,
        selectedModule,
      });
      onClose();
      setInitialFormData();
    }
  };

  // const handleSave = () => {
  //   if (!validateForm()) return;

  //   if (category === 3 && type === 1) {
  //     const purchasedValue = formData?.purchased;

  //     if (purchasedValue !== "") {
  //       if (isNaN(Number(purchasedValue))) {
  //         showToast("Purchased Creits must be a valid number", "error");
  //         return;
  //       }
  //     }
  //   }

  //   if (isEditMode) {
  //     let updateValue = {};
  //     if (category === 3 && type === 1) {
  //       //Monster
  //       updateValue = {
  //         "config.clientId": encryptAll(formData.clientId),
  //         "config.clientSecret": encryptAll(formData.clientSecret),
  //         "config.cat": encryptAll(formData.cat),
  //         "config.activeDate": formData.activeDate,
  //         "config.expireDate": formData.expireDate,
  //         "config.credits.purchased": encryptAll(formData?.purchased),
  //         name: formData?.name,
  //       };
  //     } else if (category === 3 && type === 2) {
  //       //Career Builder
  //       updateValue = {
  //         "config.credentials.email": encryptAll(formData.email),
  //         "config.credentials.password": encryptAll(formData.password),
  //         "config.custAccCode": encryptAll(formData.custAccCode),
  //         name: formData?.name,
  //       };
  //     } else if (category === 7 && type === 1) {
  //       // Google Productivity
  //       updateValue = {
  //         "config.clientID": encryptAll(formData.clientID),
  //         "config.clientSecret": encryptAll(formData.clientSecret),
  //         name: formData.name,
  //       };
  //     } else if (selectedModule === "ats" && category === 6 && type === 1) {
  //       updateValue = {
  //         "config.key": encryptAll(formData.key),
  //         "config.model": encryptAll(formData.model),
  //         "config.serviceType": formData.serviceType,
  //         name: formData.name,
  //       };
  //     } else {
  //       for (const [key, value] of Object.entries(formData)) {
  //         if (key === "name") {
  //           updateValue[key] = value;
  //         } else {
  //           if (selectedModule === "bs") {
  //             if (category === 6 && type === 1) {
  //               updateValue = {
  //                 key: encryptAll(formData.key),
  //                 model: encryptAll(formData.model),
  //                 serviceType: formData.serviceType,
  //                 name: formData.name,
  //               };
  //             } else {
  //               updateValue[key] = encryptAll(value);
  //             }
  //           } else {
  //             updateValue[`config.${key}`] = encryptAll(value);
  //           }
  //         }
  //       }
  //     }

  //     onSave({
  //       payload: [
  //         {
  //           type: "SET",
  //           value: updateValue,
  //         },
  //       ],
  //       uiid: existingData?.uiid,
  //       isEditMode,
  //       category,
  //       type,
  //       name: formData.name,
  //       selectedModule
  //     });
  //     onClose();
  //   } else {
  //     let updatedConfig =
  //       category === 3
  //         ? type === 1 //Monster
  //           ? {
  //               clientId: formData.clientId,
  //               clientSecret: formData.clientSecret,
  //               cat: formData.cat,
  //               activeDate: formData.activeDate,
  //               expireDate: formData.expireDate,
  //               credits: { purchased: formData?.purchased },
  //             }
  //           : type === 2 //Career Builder
  //           ? {
  //               credentials: {
  //                 email: formData.email,
  //                 password: formData.password,
  //               },
  //               custAccCode: formData.custAccCode,
  //             }
  //           : { ...formData }
  //         : category === 7
  //         ? type === 1
  //           ? {
  //               clientID: formData.clientID,
  //               clientSecret: formData.clientSecret,
  //             }
  //           : type === 2
  //           ? {
  //               clientID: formData.clientID,
  //               clientSecret: formData.clientSecret,
  //               redirectUri: formData.redirectUri,
  //               callbackRedirect: formData.callbackRedirect,
  //               endpoint: formData.endpoint,
  //               webhookUrl: formData.webhookUrl,
  //             }
  //           : { ...formData }
  //         : category === 6
  //         ? type === 1
  //           ? {
  //               key: formData.key,
  //               model: formData.model
  //             }
  //           : {...formData}
  //         : { ...formData };

  //     if (category === 11) {
  //       const { name, ...rest } = updatedConfig;
  //       updatedConfig = rest;
  //     }

  //     updatedConfig = encryptAll(updatedConfig);

  //     //Non Encrypted fields
  //     if (category === 6 && type === 1) {
  //       updatedConfig = {...updatedConfig, serviceType: formData?.serviceType}
  //     }

  //     onSave({
  //       updatedConfig,
  //       category,
  //       type,
  //       name: formData.name,
  //       selectedModule
  //     });
  //     onClose();
  //   }
  // };

  const handleInputChange = (fieldName, value) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const setInitialFormData = () => {
    const initialData = {};
    if (existingData) {
      const decryptedConfig = decryptAll(existingData?.config);

      if (selectedModule === "bs") {
        config?.fields.forEach((field) => {
          initialData[field.name] = field?.isEncrypted
            ? decryptAll(existingData[field.name])
            : existingData[field.name];
        });
      } else {
        config?.fields.forEach((field) => {
          initialData[field.name] =
            decryptedConfig?.[field.name] || existingData[field.name] || "";
        });
      }

      if (category === 3 && type === 1) {
        initialData["purchased"] = decryptedConfig?.credits?.purchased;
        initialData["activeDate"] = existingData.config?.activeDate;
        initialData["expireDate"] = existingData.config?.expireDate;
      }
      if (category === 3 && type === 2) {
        initialData["email"] = decryptedConfig?.credentials?.email;
        initialData["password"] = decryptedConfig?.credentials?.password;
      }
    } else {
      config?.fields.forEach((field) => {
        initialData[field.name] = field.value || "";
      });
    }
    setFormData(initialData);
  };

  useEffect(() => {
    setInitialFormData();
  }, [existingData, config]);

  const handleDateChange = (name, value) => {
    const dateOnly = value.toISOString().split("T")[0];
    handleInputChange(name, value);
  };

  const handleModelColse = () => {
    setInitialFormData();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleModelColse}
      title={isEditMode ? `Edit ${config.name}` : `Connect ${config.name}`}
      width="max-w-4xl"
      titleColor="primary"
    >
      <div className="grid grid-cols-3 gap-4 py-5">
        {config.fields.map((field) => (
          <FormFieldSet
            key={field.name}
            type={field.type}
            title={field.label}
            placeholder={`Enter ${field.label}`}
            value={formData[field.name] || field.value || ""}
            options={field?.options && field?.options}
            onChange={
              field.type === "text"
                ? (value) => {
                    handleInputChange(field.name, value);
                  }
                : field.type === "password"
                  ? (e) => handleInputChange(field.name, e.target.value)
                  : field.type === "datepicker"
                    ? (value) => handleDateChange(field.name, value)
                    : (value) => handleInputChange(field.name, value)
            }
            required={field.required}
            disabled={field.disabled}
            error={errors[field.name]}
          />
        ))}
        {category === 11 && (type === 7 || type === 8) && (
          <Button
            title="Configure"
            className="py-2 h-10 mt-4"
            onClick={() => {
              if (!formData.name?.trim()) {
                showToast("Please enter Display Name", "error");
                return;
              }

              if (type === 7) {
                handleVerifyGmail(
                  formData.name,
                  async ({ email, authId }) => {
                    //  THIS RUNS ONLY AFTER SUCCESS
                    console.log({ authId });
                    await onSave({
                      category,
                      type,

                      name: formData.name,
                      email: email,
                      authId: Number(authId),
                      selectedModule,
                      isOAuth: true, // optional flag
                    });

                    showToast("Gmail connected successfully", "success");
                  },
                  handleModelColse,
                );
              } else if (type === 8) {
                handleVerifyOutlook(
                  formData.name,
                  async ({ email, authId }) => {
                    //  THIS RUNS ONLY AFTER SUCCESS
                    console.log({ authId });
                    await onSave({
                      category,
                      type,

                      name: formData.name,
                      email: email,
                      authId: Number(authId),
                      selectedModule,
                      isOAuth: true, // optional flag
                    });

                    showToast("Outlook connected successfully", "success");
                  },
                  handleModelColse,
                );
              }
            }}
          />
        )}

        {/* {currentUserDetails?.data?.role?.module === 1 && (
          <FormFieldSet
            type="checkbox"
            size="md"
            title="Select Module"
            options={[
              { label: "ATS", value: "ats" },
              { label: "Bench Sales", value: "bs" },
            ]}
            values={selectedModule}
            onChange={(val) => setSelectedModule(val)}
            multiple
          />
        )} */}
      </div>

      <div className="flex justify-end gap-5 mt-5 ">
        <Button title="Cancel" variant="outlined" onClick={handleModelColse} />
        <Button title="Save" onClick={handleSave} />
      </div>
    </Modal>
  );
};

export default AddAccountModel;
